import axios from "axios";
import {API_LOGISTICAL_LOTS} from '../api.js';
import crudApi from "./crudApi";

class LogisticalLot extends crudApi {
    async create(data, options = {}) {
        return await axios.post(API_LOGISTICAL_LOTS, data, options);
    }

    getLatest(options = {}) {
        return axios.get(`${API_LOGISTICAL_LOTS}/latest`, options);
    }

    async edit(data, options = {}) {
        return await axios.patch(`${API_LOGISTICAL_LOTS}/${data.id}`, data, options);
    }

    async createAndGetDeliveryReport(companyId, options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/${companyId}/delivery_report`, options)
    }

    async getDeliveryReport(companyId, editedAt, options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/${companyId}/delivery_report/${editedAt}`, options)
    }

    async getXlsx( options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/xlsx`, options);
    }

    async getLogisticalLotXlsx( id, options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/lot_xlsx/${id}`, options);
    }

    async getLotQrCode( id, options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/lot_qr_code/${id}`, options);
    }

    async getLotsQrCodeRapport( options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/lots_qr_code_rapport`, options);
    }

    async printSticker(data, options = {}) {
        return await axios.post(`${API_LOGISTICAL_LOTS}/print_sticker`, data, options)
    }

    async getQrCode(id, options = {}) {
        return await axios.get(`${API_LOGISTICAL_LOTS}/qr_code/${id}`, options)
    }
};

export default new LogisticalLot(API_LOGISTICAL_LOTS);
